<ng-container *ngIf="resource">
  <div *ngIf="hasImage" class="resource-tile__image-wrapper">
    <cx-media
      [alt]="resource.source.name" [container]="{url: resource.source.logo}"
      [title]="resource.source.name"
      class="tile-img"
    ></cx-media>
  </div>
  <div [class.pt-4]="hasImage && imageTop" [class.pt-5]="!hasImage || !imageTop"
       class="d-flex flex-grow-1 flex-column px-4 pb-5">
    <div *ngIf="hasLabel" class="ds-fine-print">{{resource.label}}</div>
    <div
      [class.mt-2]="hasLabel && (hasImage || hasDescription)"
      [class.mt-3]="hasLabel && !hasImage && !hasDescription"
      class="ds-heading--{{headlineSize}}"
    >
      {{resource.text}}
    </div>
    <div *ngIf="hasDescription && !hasImage" class="w-100 separator pt-4"></div>
    <div *ngIf="hasDescription" [class.mt-3]="hasImage" [class.mt-4]="!hasImage" class="ds-fine-print">
      {{resource.description}}
    </div>
    <div class="mt-auto">
      <dcp-product-type-display [type]="resource.type" [value]="resource.value"></dcp-product-type-display>
    </div>
  </div>
</ng-container>
